module.exports = __webpack_public_path__ + "static/media/6.5b447478.png";